module.exports = __webpack_public_path__ + "img/professional_img_6.a683da62.png";